var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M256,512c77.591,0,147.114-34.524,194.061-89.043H61.939C108.886,477.476,178.409,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M512,256C512,114.616,397.384,0,256,0S0,114.616,0,256c0,23.107,3.08,45.489,8.819,66.783h494.363 C508.92,301.489,512,279.107,512,256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M20.348,356.174c4.935,11.596,10.704,22.748,17.227,33.391h436.852 c6.521-10.644,12.29-21.796,17.227-33.391H20.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "182.99,272.696 187.134,285.45 200.545,285.45 189.696,293.333 193.84,306.087  182.99,298.204 172.14,306.087 176.285,293.333 165.436,285.45 178.847,285.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "182.99,439.652 187.134,452.407 200.545,452.407 189.696,460.289 193.84,473.043  182.99,465.161 172.14,473.043 176.285,460.289 165.436,452.407 178.847,452.407  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "105.274,383.189 109.418,395.942 122.829,395.942 111.98,403.824 116.124,416.58  105.274,408.697 94.424,416.58 98.57,403.824 87.72,395.942 101.13,395.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "134.959,289.391 139.103,302.146 152.513,302.146 141.665,310.028 145.809,322.783  134.959,314.9 124.109,322.783 128.255,310.028 117.404,302.146 130.815,302.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "87.72,341.915 101.128,341.916 105.273,329.159 109.418,341.915 122.829,341.914  111.979,349.797 116.124,362.552 105.273,354.669 94.424,362.549 98.568,349.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "124.11,453.911 128.254,441.159 117.403,433.277 130.814,433.277 134.959,420.522  139.104,433.276 152.514,433.276 141.664,441.158 145.808,453.914 134.958,446.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "260.677,383.189 256.534,395.942 243.123,395.942 253.971,403.824 249.827,416.58  260.677,408.697 271.527,416.58 267.382,403.824 278.232,395.942 264.821,395.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "230.992,289.391 226.849,302.146 213.438,302.146 224.286,310.028 220.142,322.783  230.992,314.9 241.842,322.783 237.697,310.028 248.547,302.146 235.136,302.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "278.232,341.915 264.823,341.916 260.678,329.159 256.534,341.915 243.123,341.914  253.972,349.797 249.827,362.552 260.678,354.669 271.527,362.549 267.383,349.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "241.841,453.911 237.698,441.159 248.548,433.277 235.137,433.277 230.992,420.522  226.848,433.276 213.437,433.276 224.287,441.158 220.143,453.914 230.993,446.03  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.a9e22df0dcdac96cc7c23bbf46cb0901.svg";
export { ForwardRef as ReactComponent };